import { toast } from "react-toastify";
import APIPaths from "../../utils/APIPaths";
import axiosInstance from "../axiosInstance";
import RoutingPaths from "../../utils/RoutingPaths";
import moment from "moment";

function formatDate(date) {
  return moment.utc(date).format("YYYY-MM-DDTHH:mm:ss[Z]");
}

export const consultantLoginService = async (bodyObj, navigate) => {
  try {
    const { data } = await axiosInstance.post(
      APIPaths.CONSULTANT_SIGN_IN,
      bodyObj,
    );

    const { token } = data.data;

    if (token) {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem(
        "ConsultantDetails",
        JSON.stringify(data.data?.consultantDto),
      );
      sessionStorage.setItem(
        "isPaymentInfoAccessAllowed",
        JSON.stringify(
          data.data?.consultantDto?.isPaymentInfoAccessAllowed !== null
            ? data.data?.consultantDto?.isPaymentInfoAccessAllowed
            : false,
        ),
      );
      sessionStorage.setItem(
        "googleClientId",
        JSON.stringify(data.data?.googleClientId),
      );
      sessionStorage.setItem(
        "googleRedirectUri",
        JSON.stringify(data.data?.googleRedirectUri),
      );
      sessionStorage.setItem(
        "SelectedBranch",
        JSON.stringify(data.data?.consultantDto?.selectedBranchId),
      );
      let imageTypeId;
      const imageTypeResponse = await getImageTypeList();
      if (imageTypeResponse) {
        const profileImageType = imageTypeResponse.find(
          (imageTypeResponse) => imageTypeResponse.type === "PROFILE_IMAGE",
        );
        if (profileImageType) {
          imageTypeId = profileImageType.id;
        }
      }

      await getConsultantLogoHandler(data.data?.consultantDto.id, imageTypeId);
      navigate(RoutingPaths.DASHBOARD);
      toast.success("Logged in successfully.");
      return;
    }
  } catch (error) {
    if (error?.response && error?.response?.data) {
      toast.error(error?.response?.data?.message);
    } else {
      toast.error("The provided email ID or password is invalid.");
    }
    return;
  }
};

export const consultantForgotPasswordService = async (bodyObj, navigate) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.CONSULTANT_FORGOT_PASSWORD,
      bodyObj,
    );

    if (response.status === 200) {
      navigate(
        RoutingPaths.FORGOT_PASSWORD_VALIDATE_TOKEN + "/" + bodyObj.userType,
        {
          state: {
            userName: bodyObj?.userName,
          },
        },
      );
      toast.success(response.data?.message);
    }

    return response;
  } catch (error) {
    const errorMessage =
      error.response.data.message ??
      error.response?.data ??
      "An error occurred while validating email.";
    toast.error(errorMessage);
    return;
  }
};

export const consultantForgotPasswordValidateTokenService = async (
  bodyObj,
  navigate,
) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.CONSULTANT_FORGOT_PASSWORD_VALIDATE_TOKEN,
      bodyObj,
    );
    if (response.status === 200) {
      navigate(RoutingPaths.FORGOT_PASSWORD_CHANGE + "/" + bodyObj.userType, {
        state: {
          userName: bodyObj?.userName,
          bodyObj,
        },
      });
      toast.success(response.data?.message);
    }

    return;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ??
      "An error occurred while validating token.";
    toast.error(errorMessage);
    return;
  }
};

export const consultantForgotPasswordChangeService = async (
  bodyObj,
  navigate,
) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.CONSULTANT_FORGOT_PASSWORD_CHANGE,
      bodyObj,
    );

    if (response.status === 200) {
      navigate(RoutingPaths.LOGIN);
      toast.success(response.data?.message);
    }

    return response;
  } catch (error) {
    if (error.response?.data?.errors?.newPassword) {
      toast.error(error.response?.data?.errors?.newPassword);
    } else {
      toast.error(error.response?.data?.message);
    }
    return;
  }
};

export const addConsultant = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_CONSULTANT, bodyObj);
    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong.");
    }
  }
};

export const addConsultantImage = async (data) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.ADD_CONSULTANT_IMAGE,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data);
  }
};

export const updateConsultant = async (bodyObj, consultantId) => {
  try {
    const URL = APIPaths.UPDATE_CONSULTANT + consultantId;
    const response = await axiosInstance.put(URL, bodyObj);
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong.");
    }
  }
};

export const updateConsultantImage = async (consultantId, data) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.UPDATE_CONSULTANT_IMAGE + consultantId,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data);
  }
};

export const addConsultantAddress = async (bodyObj) => {
  const response = axiosInstance
    .post(APIPaths.POST_ADD_ADDRESS, bodyObj)
    .then((response) => {
      if (response.status === 201) {
        return response;
      }
    })
    .catch((error) => {
      if (error.response.data.errors) {
        for (const item in error.response.data.errors) {
          toast.error(error.response.data.errors[item]);
        }
      } else {
        toast.error(error.response.statusText);
      }
      return null;
    });
  return response;
};

export const updateConsultantAddress = async (bodyObj, addressId) => {
  try {
    const URL = APIPaths.UPDATE_CONSULTANT_ADDRESS + addressId;
    const response = await axiosInstance.put(URL, bodyObj);
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.statusText);
    }
  }
};

export const addConsultantTiming = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.ADD_CONSULTANT_TIMING,
      bodyObj,
    );

    if (response.status === 201) {
      toast.success(response.data.message);
      return response;
    }
  } catch (error) {
    toast.error(error.response.data);
    return error.response.data;
  }
};

export const updateConsultantTiming = async (bodyObj, consultantId) => {
  try {
    const URL = APIPaths.UPDATE_CONSULTANT_TIMING + consultantId;
    const response = await axiosInstance.put(URL, bodyObj);
    if (response.status === 202) {
      return response;
    }
  } catch (error) {
    toast.error(error.response.data);
    return error.response.data;
  }
};

export const getConsultantList = async (page, rowsPerPage, value) => {
  try {
    const URL = `${APIPaths.GET_CONSULTANT_LIST}/${page}/${rowsPerPage}/${value}`;
    const response = await axiosInstance.get(URL);
    if (response.status === 200 || response.status === 204) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const getConsultantById = async (id) => {
  try {
    const URL = APIPaths.GET_CONSULTANT_BY_ID + id;
    const response = await axiosInstance.get(URL);

    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const getConsultantImage = async (id, imageTypeId) => {
  const cid = id;
  const itId = imageTypeId;
  try {
    const URL = `${APIPaths.GET_CONSULTANT_IMAGE}/${cid}/${itId}`;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
    });
    if (response.status === 200) {
      return response;
    }
    return response;
  } catch (error) {
    return [];
  }
};

/**
 * Method Get Prescription Background Image
 * @param {*} consultantId
 * @returns
 */
export const getPrescriptionBackgroundImage = async (id) => {
  const cid = id;
  try {
    const URL = `${APIPaths.GET_PRESCRIPTION_BACKGROUND_IMAGE}/${cid}`;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
    });
    if (response.status === 200) {
      return response;
    }
    return response;
  } catch (error) {}
};

export const getConsultantAllAddresses = async (id) => {
  try {
    const URL = `${APIPaths.GET_CONSULTANT_ADDRESSES}/${id}`;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getImageTypeList = async () => {
  try {
    const response = await axiosInstance.get(APIPaths.GET_IMAGE_TYPES);
    return response.data;
  } catch (error) {
    return [];
  }
};

export const deleteConsultantImageByConsultantId = async (
  id,
  deletePrescriptionBackgroundImage,
  deleteConsultantProfileImage,
) => {
  try {
    const URL = APIPaths.DELETE_CONSULTANT_IMAGE + id;
    const response = await axiosInstance.delete(URL, {
      params: {
        removePrescriptionBackgroundImg: deletePrescriptionBackgroundImage,
        removeConsultantProfileImg: deleteConsultantProfileImage,
      },
    });

    if (response.status === 200) {
      return response.status;
    } else {
      return null;
    }
  } catch (error) {}
};

export const getTodaysAppointmentListForConsultant = async (
  searchData,
  page,
  rowsPerPage,
  addressId,
) => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const formattedToday = formatDate(today);
  const formattedTomorrow = formatDate(tomorrow);
  const URL = `${APIPaths.GET_APPOINTMENTS_FOR_CONSULTANT_BY_DATE}${formattedToday}/${formattedTomorrow}/${page}/${rowsPerPage}`;

  try {
    const response = await axiosInstance.get(URL, {
      params: {
        text: searchData,
        addressId: addressId,
      },
    });

    if (response.status === 200) {
      return response;
    } else if (response.status === 204) {
      return [];
    }
  } catch (error) {}
};

export const getConsultant = async () => {
  try {
    const URL = APIPaths.GET_CONSULTANT;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const getConsultantLogoHandler = async (id, imageTypeId) => {
  const cid = id;
  const itId = imageTypeId;
  try {
    const URL = `${APIPaths.GET_CONSULTANT_IMAGE}/${cid}/${itId}`;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
    });

    if (response.status === 200) {
      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          "",
        ),
      );
      sessionStorage.setItem(
        "ConsultantLogo",
        `data:image/jpeg;base64,${base64}`,
      );
    } else {
      sessionStorage.setItem("ConsultantLogo", null);
    }
    return null;
  } catch (error) {}
};

export const getColorCodeList = async () => {
  try {
    const response = await axiosInstance.get(APIPaths.GET_COLOR_CODE);
    return response.data;
  } catch (error) {
    return [];
  }
};

/**
 * Get Method to validate unique color code
 * @param {*} colorCode
 * @param {*} consultantId
 * @returns
 */
export const validateColorCodeForConsultant = async (
  colorCode,
  consultantId,
) => {
  try {
    const URL = APIPaths.VALIDATE_COLOR_CODE;
    const response = await axiosInstance.get(URL, {
      params: {
        colorHexCode: colorCode,
        consultantId: consultantId,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    toast.error(error.response.data);
    return [];
  }
};

export const addCalendarConsent = async (code, redirectUri, Id) => {
  try {
    const URL = APIPaths.CALENDAR_CONSENT;
    const response = await axiosInstance.get(URL, {
      params: {
        code: code,
        redirectUri: redirectUri,
        consultantId: Id,
      },
    });
    if (response?.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getIsConsultantAuthorized = async (Id) => {
  try {
    const URL = APIPaths.IS_CONSULTANT_AUTHORIZE;
    const response = await axiosInstance.get(URL, {
      params: {
        consultantId: Id,
      },
    });
    if (response?.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error("Something went wrong!");
    console.error(error);
    return {};
  }
};

export const unauthorizeConsultant = async (Id) => {
  try {
    const URL = APIPaths.CONSULTANT_UNAUTHORIZE;
    const response = await axiosInstance.get(URL, {
      params: {
        consultantId: Id,
      },
    });
    if (response?.status === 200) {
      return response;
    }
  } catch (error) {
    toast.error("Something went wrong!");
    console.error(error);
    return {};
  }
};

export const deleteConsultantById = async (consultantId, navigate) => {
  try {
    const URL = `${APIPaths.DELETE_CONSULTANT_BY_ID}${consultantId}`;
    const response = await axiosInstance.delete(URL);
    if (response && response.data) {
      toast.success(response.data);
    } else {
      toast.success("Consultant deleted successfully!");
    }
    navigate(RoutingPaths.CONSULTANT_DETAILS);
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("An unexpected error occurred.");
    }
    console.error(error);
  }
};

export const getConsultantAvailableTimingsByDay = async (
  id,
  date,
  addressId,
) => {
  try {
    const URL = `${APIPaths.GET_CONSULTANT_AVAILABLE_TIME_BY_DAY}${id}/getTiming/${date}/${addressId}`;

    const response = await axiosInstance.get(URL);

    if (response.status === 200) {
      return response.data;
    } else {
      toast.error(response.response?.data);
      return null;
    }
  } catch (error) {}
};
